import { render, staticRenderFns } from "./GameProjects.vue?vue&type=template&id=8a2ca30c"
import script from "./GameProjects.vue?vue&type=script&lang=ts"
export * from "./GameProjects.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports